import { render } from "./RosaryPrayers.vue?vue&type=template&id=ef7682e0&scoped=true"
import script from "./RosaryPrayers.vue?vue&type=script&lang=js"
export * from "./RosaryPrayers.vue?vue&type=script&lang=js"

import "./RosaryPrayers.vue?vue&type=style&index=0&id=ef7682e0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7682e0"]])

export default __exports__